// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import yaml from 'js-yaml';
import { API, TenantConfigContext } from 'context/TenantConfigContext';
import { useContext, useMemo } from 'react';
import { PageContainer, PageSectionTitle, Tile } from 'components/Layout/PageContainer';
import { FormattedMessage } from 'react-intl';
import apiYaml from './tb360-api_v1.yaml';
import { ApiTeaser } from './components/ApiTeaser';

function ApiAccessDocumentation() {
  const { permissions } = useContext(TenantConfigContext);
  const hasApiPermission = useMemo(() => permissions.includes(API), [permissions]);
  const parsedData = yaml.load(JSON.stringify(apiYaml));
  return (
    <PageContainer>
      {!hasApiPermission && <ApiTeaser />}
      <PageSectionTitle>
        <FormattedMessage id="api_access.documentation.tb360_api.title" />
      </PageSectionTitle>
      <Tile>
        <FormattedMessage id="api_access.documentation.tb360_api.description" />
      </Tile>
      <Tile>
        <div id="elements-api" className="bg-snow-50 p-6 mt-6" data-testid="api-documentation-elements-doc">
          <elements-api apiDescriptionDocument={yaml.dump(parsedData)} layout="stacked" hideTryIt="true" />
        </div>
      </Tile>
    </PageContainer>
  );
}

export { ApiAccessDocumentation };
